import { Controller } from "@hotwired/stimulus"
import $ from 'jquery'

export default class extends Controller {
  static targets = [
    'dialog',
    'step1',
    'step2',
    'step3',
    'step4',
    'step5',
    'nextBtn',
    'okBtn',
    'closeBtn',
    'cancelBtn',
    'qrcode',
    'verifyOTP',
    'message',
    's5Message',
    'step5Request',
    'step5Response',
    'step5Codes',
    'authForm',
  ]
  static values = {
    qrcodeUrl: String,
    validateUrl: String,
    backupCodesUrl: String,
  }

  connect() {
    // ask the parent to reload the page
    $(this.dialogTarget).on('closed.zf.reveal', ()=> this.dispatch("reload", {prefix: false}))
    this.#show(this.step1Target)
    this.#show(this.nextBtnTarget)
    this.#show(this.cancelBtnTarget)
    this.#hide(this.step2Target)
    this.#hide(this.step3Target)
    this.#hide(this.step4Target)
    this.#hide(this.step5Target)
    this.#hide(this.okBtnTarget)
    this.#hide(this.closeBtnTarget)
  }

  next() {
    if(!this.step1Target.classList.contains('hide')) this.step1()
    else if(!this.step2Target.classList.contains('hide')) this.step2()
    else if(!this.step3Target.classList.contains('hide')) this.step3()
  }

  step1() {
    this.#beginLoad()
    this.qrcodeTarget.addEventListener('load', ()=> {
      this.#endLoad()
    }, {once: true})
    this.qrcodeTarget.src = this.qrcodeUrlValue

    this.#hide(this.step1Target)
    this.#show(this.step2Target)
  }

  step2() {
    this.#hide(this.step2Target)
    this.#show(this.step3Target)
    this.verifyOTPTarget.value = ''
    this.verifyOTPTarget.focus()
  }

  async step3() {
    let csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

    this.#beginLoad()

    const req = new Request(this.validateUrlValue)
    const params = {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-CSRF-Token': csrfToken,
      },
      'body': JSON.stringify({otp: this.verifyOTPTarget.value})
    }
    let response = await fetch(req, params)

    this.messageTarget.classList.add('hide')
    if(response.status < 300) {
      this.step4()
    } else {
      this.messageTarget.classList.remove('hide')
    }

    this.#endLoad()
  }

  step4() {
    this.#hide(this.step1Target)
    this.#hide(this.step2Target)
    this.#hide(this.step3Target)
    this.#show(this.step4Target)
    this.#hide(this.nextBtnTarget)
    this.#hide(this.cancelBtnTarget)
    this.#show(this.closeBtnTarget)
  }

  step5() {
    this.#hide(this.step1Target)
    this.#hide(this.step2Target)
    this.#hide(this.step3Target)
    this.#hide(this.step4Target)
    this.#show(this.step5Target)
    this.#hide(this.nextBtnTarget)
    this.#show(this.okBtnTarget)
    this.#hide(this.cancelBtnTarget)
    this.#show(this.closeBtnTarget)
    this.generateBackupCodes()
  }

  async generateBackupCodes() {
    let csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

    this.#beginLoad()

    let headers = {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'X-CSRF-Token': csrfToken,
    }

    headers = Object.assign(headers, await this.#authController.authHeaders())

    this.authFormTarget.dataset['users-AuthenticationFormErrorsValue'] = JSON.stringify([])

    const req = new Request(this.backupCodesUrlValue)
    const params = {
      method: 'PATCH',
      headers: headers,
      'body': JSON.stringify({})
    }
    let response = await fetch(req, params)

    if(response.status < 300) {
      let data = await response.json()

      this.#hide(this.step5RequestTarget)
      this.#show(this.step5ResponseTarget)
      let html = data.codes.map((c)=> `<div class="cell medium-6">${c}</div>`)
      this.step5CodesTarget.innerHTML = html.join('');
      this.#hide(this.okBtnTarget)
      this.#hide(this.cancelBtnTarget)
      this.#show(this.closeBtnTarget)
    } else if (response.status === 403) {
      const {error, messages, credentials} = await response.json()
      this.authFormTarget.dataset['users-AuthenticationFormMethodsValue'] = JSON.stringify(credentials)
      this.authFormTarget.dataset['users-AuthenticationFormErrorsValue'] = JSON.stringify(messages)
    }

    this.#endLoad()
  }

  get #authController() {
    return this.application.getControllerForElementAndIdentifier(this.authFormTarget, 'users--authentication-form')
  }

  #beginLoad() {
    if(!this._mask) {
      this._mask = document.createElement('div')
      this._mask.classList.add('loading-mask')
      this._mask.innerHTML = '<i class="fas fa-spinner fa-3x fa-spin"></i>'
      this.dialogTarget.appendChild(this._mask)
    }
  }

  #endLoad() {
    if(this._mask) {
      this._mask.remove()
      this._mask = null
    }
  }

  #hide(el) {
    el.classList.add('hide')
  }

  #show(el) {
    el.classList.remove('hide')
  }
}
